import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { ConfigService } from '@services/webFeeder/config.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {

  constructor(
    private router: Router,
    private config: ConfigService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.config.writeLog('AUTH GUARD > isAuthenticadSystem: ' + this.config.isAuthenticadSystem());
    if (this.config.isAuthenticadSystem()) {
      return true;
    }
    this.config.writeLog('AUTH GUARD > redireciona para a tela de login - state.url ' + state.url);
    this.config.REDIRECT_LOGOUT();
    return false;
  }
}
